import "./JoinColleagues.scss";

const JoinColleagues = () => {
  return (
    <div
      className="joinColleagues"
      style={{
        backgroundSize: "cover",
      }}
    >
      <div className="joinSubContainer">
        <h1>Join your colleagues, classmates, and friends on LinkedIn.</h1>
        <button>Get started</button>
      </div>
    </div>
  );
};

export default JoinColleagues;
